import { useParams } from 'react-router-dom';

import ColoredOverlayWindow from 'src/legacy/Components/Windows/ColoredOverlayWindow';


import { useEventHistory } from '../hooks';

const CheckoutError = () => {
  const eventHistory = useEventHistory();
  const {eventID} = useParams()

  const goToPage = () => {
    eventHistory.replace(`/event/${eventID}`);
  };

  return (
    <ColoredOverlayWindow
      show={true}
      title="Não foi possível abrir venda"
      requestStatus="openError"
      style={{ backgroundColor: 'var(--chakra-colors-purple-500)' }}
      {...{ goToPage }}
      buttonText={undefined}>
      Houve um problema ao tentar abrir sua venda, verifique sua conexão e tente
      novamente, caso acredite se tratar de um problema no site, entre em
      contato conosco.
    </ColoredOverlayWindow>
  );
};

export default CheckoutError;
